<template>
	<div class="zjjb">
		<!-- zjjb -->
		<ul class="title1">
			<li class="L"><router-link to="/jianbao">中经简报</router-link></li>
			<li class="M"></li>
			<li class="R"><router-link to="/jianbao" class="more3">更多</router-link></li>
		</ul>
		<el-skeleton :rows="12" :loading="isloading" animated >
			<div class="zjjb_list">
				<!-- zjjb_list -->
				<item v-for="(item,index) in jianbaoList.data" class="item">
					<!-- item -->
					<h1><router-link :to="{ name: 'jianbao',params:{column:item.articletype}}">{{item.articletype}}</router-link></h1>
					<a @click="jumppush('/detail/'+item.id+'?col=jianbao')" >
						<img :src="jianbaoList.images[item.id]?jianbaoList.images[item.id]:'images/hot_img.jpg'" style="width: 160px;height: 128px;" alt="" />
					</a>
					<div class="list">
						<a @click="jumppush('/detail/'+item.id+'?col=jianbao')"  style="display: inline-block;height: 104px;">
							<h2>{{item.title}}</h2>
						</a>
						<!-- <h3><span>{{item.source}}</span>|<span>{{item.publishtime?item.publishtime.substring(0,10):''}}</span></h3> -->
						<a @click="jumppush('/detail/'+item.id+'?col=jianbao')" class="more1" >
							{{item.articletitle}}
						</a>
					</div>
				</item><!-- /item -->
			</div><!-- /zjjb_list -->
		</el-skeleton>
	</div><!-- /zjjb -->
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				jianbaoList: [],
			}
		},
		created: function() {
			this.jianbaofnc();
		},
		computed: {

		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					this.$cookies.set('fromdetail',to);
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			jianbaofnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'searchArticles',
						responseType: 'json',
						params: {
							columnID: '57fd9c2506ea4afabadb154e1b79a148',
							isTopArticle: '1',
							iPage:'1',
							pageSize:'6',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.jianbaoList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
		}
	}
</script>

<style>
</style>
